export const FEATURE_ACHIEVEMENTS = 'achievements'
export const FEATURE_ACTIVITY_LOG = 'activity-log'
export const FEATURE_ACTIVITY_LOG_COMPANY = 'activity-log-company'
export const FEATURE_AUDIT_LOG = 'audit-log'
export const FEATURE_AD_AVERAGE_ACTIVITY_TIME_LP = 'ad-average-activity-time-lp'
export const FEATURE_AD_AVERAGE_COMPLETION_RESULT_METRIC =
  'ad-average-completion-result'
export const FEATURE_AD_AVERAGE_COURSE_RATING = 'ad-average-course-rating'
export const FEATURE_AD_AVERAGE_SCORE_POWER_SKILLS =
  'ad-average-score-power-skills'
export const FEATURE_AD_COMPLETED_COURSES = 'ad-completed-courses'
export const FEATURE_AD_COMPLETED_LESSONS = 'ad-completed-lessons'
export const FEATURE_AD_COURSE_STARTERS_COMPLETERS =
  'ad-courses-starters-completers'
export const FEATURE_AD_HIGHEST_LEVEL_POWER_SKILL =
  'ad-highest-level-power-skill'
export const FEATURE_AD_HIGHEST_LEVEL_POWER_SKILLS =
  'ad-highest-level-power-skills'
export const FEATURE_AD_LP_ACTIVITY_BY_TYPE = 'ad-lp-activity-by-type'
export const FEATURE_AD_LESSONS_RATINGS_TOTAL = 'ad-lessons-ratings-total'
export const FEATURE_AD_LICENSES = 'ad-licenses'
export const FEATURE_AD_LP_ELEMENTS_ACTIVITY_BY_TYPE =
  'ad-lp-elements-activity-by-type'
export const FEATURE_AD_LP_PROGRESS = 'ad-lp-progress'
export const FEATURE_AD_LP_STARTERS_COMPLETERS = 'ad-lp-starters-completers'
export const FEATURE_AD_MOST_POPULAR_COURSE = 'ad-most-popular-course'
export const FEATURE_AD_MOST_POPULAR_DOMAIN = 'ad-most-popular-domain'
export const FEATURE_AD_MOST_POPULAR_POWER_SKILL = 'ad-most-popular-power-skill'
export const FEATURE_AD_POWER_SKILL_MOST_POINTS_ACHIEVED =
  'ad-power-skill-most-points-achieved'
export const FEATURE_AD_COURSE_STARTS_COMPLETIONS =
  'ad-course-starts-completions'
export const FEATURE_AD_LESSONS_STARTS_COMPLETIONS =
  'ad-lessons-starts-completions'
export const FEATURE_AD_LESSONS_PROGRESS = 'ad-lessons-progress'
export const FEATURE_AD_TOTAL_LESSONS_COMPLETIONS =
  'ad-total-lessons-completions'
export const FEATURE_AD_LP_STARTS_COMPLETIONS = 'ad-lp-starts-completions'
export const FEATURE_AD_LP_ELEMENTS_STARTS_COMPLETIONS =
  'ad-lp-elements-starts-completions'
export const FEATURE_AD_TOP_10_POPULAR_SEARCHES = 'ad-top-10-popular-searches'
export const FEATURE_AD_TOP_5_COMPLETED_LESSONS = 'ad-top-5-completed-lessons'
export const FEATURE_AD_TOP_5_MOST_COMPLETED_COURSES =
  'ad-top-5-most-completed-courses'
export const FEATURE_AD_TOP_5_RATED_LESSONS = 'ad-top-5-rated-lessons'
export const FEATURE_AD_TOTAL_USERS_ACTIVITY_TIME =
  'ad-total-users-activity-time'
export const FEATURE_AD_TOTAL_USERS = 'ad-total-users'
export const FEATURE_AD_USERS = 'ad-users'
export const FEATURE_AD_USERS_COMPLETED_SKILL_ASSESSMENT =
  'ad-users-completed-skills-assessment'
export const FEATURE_AD_USERS_FINISHED_FUNDAMENTAL_COURSE =
  'ad-users-finished-fundamental-course'
export const FEATURE_AD_USERS_LEARNING_GROUPS = 'ad-users-learning-groups'
export const FEATURE_AD_USERS_MIN_1_USER_RATING = 'ad-users-min-1-user-rating'
export const FEATURE_AD_USERS_POWER_SKILLS = 'ad-users-power-skills'
export const FEATURE_AD_USERS_RATED_1_COURSE = 'ad-users-rated-1-course'
export const FEATURE_AI_COURSE_DASHBOARD_POD = 'ai-course-dashboard-pod'
export const FEATURE_ANALYTICS = 'analytics'
export const FEATURE_BATCH_OPERATIONS = 'batch-operations'
export const FEATURE_BATCH_OPERATIONS_USER_EDIT = 'batch-operations-user-edit'
export const FEATURE_BATCH_OPERATIONS_USER_DEACTIVATE =
  'batch-operations-user-deactivation'
export const FEATURE_BATCH_OPERATIONS_USER_REACTIVATE =
  'batch-operations-user-reactivation'
export const FEATURE_BATCH_OPERATIONS_USER_GROUP_ASSIGN =
  'batch-operations-user-group-assignment'
export const FEATURE_BATCH_OPERATIONS_DEPARTMENT_ASSIGN =
  'batch-operations-department-assignment'
export const FEATURE_BROWSER_NOTIFICATIONS = 'browser-notifications'
export const FEATURE_CERTIFICATE = 'certificate'
export const FEATURE_TOPIC_CERTIFICATE = 'topic-certificate'
export const FEATURE_COMPANY = 'company'
export const FEATURE_CONTENT_LANGUAGE_FLAGS = 'content-language-flags'
export const FEATURE_CORE_SKILLS_ASSESSMENT = 'core-skills-assessment'
export const FEATURE_COMBINED_ACCOUNT_AND_SETTINGS_PAGES =
  'combined-account-and-settings-pages'
export const FEATURE_CHANGING_USER_NAMES_AND_EMAIL =
  'changing-user-names-and-email'
export const FEATURE_COMPANY_LEARNING_WIDGETS = 'company-learning-widgets'
export const FEATURE_DASHBOARD_ADVENT_CALENDAR_CHANNEL =
  'dashboard-advent-calendar-channel'
export const FEATURE_DASHBOARD_BEST_TOPICS_CHANNEL =
  'dashboard-best-topics-channel'
export const FEATURE_DASHBOARD_BOOKMARKED = 'dashboard-bookmarked-lectures'
export const FEATURE_DASHBOARD_CHANNELS = 'dashboard-channels'
export const FEATURE_DASHBOARD_COMPLETED = 'dashboard-completed'
export const FEATURE_DASHBOARD_COURSE = 'dashboard-course'
export const FEATURE_DASHBOARD_CURRENT_LECTURE = 'dashboard-current-lecture'
export const FEATURE_DASHBOARD_HIGHLIGHTED_TOPIC = 'dashboard-highlighted-topic'
export const FEATURE_DASHBOARD_EXCLUSIVE_CHANNEL =
  'dashboard-internal-topics-channel'
export const FEATURE_DASHBOARD_LEARNPATH = 'dashboard-learnpaths'
export const FEATURE_DASHBOARD_LEARNPATH_COMPANY =
  'dashboard-learnpaths-company'
export const FEATURE_DASHBOARD_NEW_TOPICS_CHANNEL =
  'dashboard-new-topics-channel'
export const FEATURE_DASHBOARD_USER_CHANNEL = 'dashboard-user-channel'
export const FEATURE_DISCOVER = 'discover'
export const FEATURE_DISCOVER_ADVANCED_FILTERS = 'discover-advanced-filters'
export const FEATURE_DOWNLOAD_NOTES = 'download-notes'
export const FEATURE_EXPORT_CONTENT_AS_SCORM = 'export-content-as-scorm'
export const FEATURE_GLOSSARY = 'glossary'
export const FEATURE_GROWTH_MAP = 'growth-map'
export const FEATURE_LEARNGROUP = 'learngroup'
export const FEATURE_LEARNING_ELEMENTS_TRACKING = 'learning-elements-tracking'
export const FEATURE_LEARNPATH = 'learnpath'
export const FEATURE_LEARNPATH_AS_A_COURSE = 'learnpath-as-a-course'
export const FEATURE_LEARNPATH_BLENDED_LEARNING = 'learnpath-blended-learning'
export const FEATURE_LEARNPATH_CERTIFICATE_ISSUE = 'learnpath-certificate-issue'
export const FEATURE_LEARNPATH_EMBEDDED_VIDEO = 'learnpath-embedded-video'
export const FEATURE_LEARNPATH_FILE_UPLOAD = 'learnpath-file-upload'
export const FEATURE_LEARNPATH_MANDATORY = 'learnpath-mandatory'
export const FEATURE_LEARNPATH_MASTERPLAN_CONTENT =
  'learnpath-masterplan-content'
export const FEATURE_LEARNPATH_MY_LEARNERS_ONLY_FILTER =
  'learnpath-my-learners-only-filter'
export const FEATURE_LEARNPATH_ACTIVE_ONLY_FILTER =
  'learnpath-active-only-filter'
export const FEATURE_LEARNPATH_MANDATORY_ONLY_FILTER =
  'learnpath-mandatory-only-filter'
export const FEATURE_LEARNPATH_OWNER = 'learnpath-owner'
export const FEATURE_LEARNPATH_PDF_PREVIEW = 'learnpath-pdf-preview'
export const FEATURE_LEARNPATH_POINTS = 'learnpath-points'
export const FEATURE_LEARNPATH_QUIZ = 'learnpath-quiz'
export const FEATURE_LEARNPATH_QUIZ_MULTIPLE_CHOICE =
  'learnpath-quiz-multiple-choice'
export const FEATURE_LEARNPATH_QUIZ_THRESHOLD = 'learnpath-quiz-threshold'
export const FEATURE_LEARNPATH_STATS_DEFAULT_COMPANY_ADMIN =
  'learnpath-stats-default-company_admin'
export const FEATURE_LEARNPATH_STATS_DEFAULT_MANAGER =
  'learnpath-stats-default-manager'
export const FEATURE_LEARNPATH_STATS_DEFAULT_OWNER =
  'learnpath-stats-default-owner'
export const FEATURE_LEARNPATH_STATS_MANDATORY_COMPANY_ADMIN =
  'learnpath-stats-mandatory-company_admin'
export const FEATURE_LEARNPATH_STATS_MANDATORY_MANAGER =
  'learnpath-stats-mandatory-manager'
export const FEATURE_LEARNPATH_STATS_MANDATORY_OWNER =
  'learnpath-stats-mandatory-owner'
export const FEATURE_LEARNPATH_STATS_DEACTIVATED_USERS_FILTER =
  'learnpath-stats-deactivated-users-filter'
export const FEATURE_LEARNPATH_AS_COURSE_STATS_COMPANY_ADMIN =
  'learnpath-as-a-course-stats-company_admin'
export const FEATURE_LEARNPATH_AS_COURSE_STATS_MANAGER =
  'learnpath-as-a-course-stats-manager'
export const FEATURE_LEARNPATH_AS_COURSE_STATS_OWNER =
  'learnpath-as-a-course-stats-owner'
export const FEATURE_LEARNPATH_TEXT_LECTURE = 'learnpath-text-lecture'
export const FEATURE_LEARNPATH_THUMBNAILS = 'learnpath-thumbnails'
export const FEATURE_LEARNPATH_TRANSFER_LEARNING_PROGRESS =
  'learnpath-transfer-learning-progress'
export const FEATURE_LEARNPATH_TRANSLATIONS = 'learnpath-translations'
export const FEATURE_LEARNPATH_VIDEO_UPLOAD = 'learnpath-video-upload'
export const FEATURE_LEARNPATH_RESTRICTED_ACCESS = 'learnpath-restricted-access'
export const FEATURE_LINK_SHARING = 'link-sharing'
export const FEATURE_MANAGER_LEARNPATH_VIEW = 'manager-learnpath-view'
export const FEATURE_MONTHLY_CHALLENGE = 'monthly-challenge'
export const FEATURE_NOTIFICATIONS = 'notifications'
export const FEATURE_NOTIFICATIONS_SYSTEM = 'notifications-system'
export const FEATURE_NO_EMAIL_USERS = 'no-email-users'
export const FEATURE_LP_ACTIVATION_SCHEDULING =
  'learnpath-activation-scheduling'
export const FEATURE_SIGNUP_AVATAR = 'signup-avatar'
export const FEATURE_SIGNUP_DATE_OF_BIRTH = 'signup-date-of-birth'
export const FEATURE_SIGNUP_EMAIL_REQUIRED = 'signup-email-required'
export const FEATURE_SIGNUP_FIELD_OF_ACTIVITY = 'signup-field-of-activity'
export const FEATURE_SIGNUP_GENDER = 'signup-gender'
export const FEATURE_SIGNUP_POLL = 'signup-poll'
export const FEATURE_SIGNUP_PRIVACY_POLICY = 'signup-privacy-policy'
export const FEATURE_SIGNUP_PRIVACY_POLICY_VOLKSWAGEN =
  'signup-privacy-policy-volkswagen'
export const FEATURE_SIGNUP_PROFILE = 'signup-profile'
export const FEATURE_SOCIAL_AUTH = 'social-auth'
export const FEATURE_USERPILOT = 'userpilot'
export const FEATURE_USER_NOTES = 'user-notes'
export const FEATURE_USER_DEACTIVATION = 'user-deactivation'
export const FEATURE_USER_DELETION = 'user-deletion'
export const FEATURE_USER_GROUPS = 'user-groups'
export const FEATURE_USER_GROUP_MEMBERS_EXPORT = 'user-group-members-export'
export const FEATURE_USER_MANAGEMENT = 'user-management'
export const FEATURE_USERS_EXPORT = 'users-export'
export const FEATURE_VIDEO_PLAYER_THUMBNAILS = 'video-player-thumbnails'
export const FEATURE_SNOW = 'snow'
export const FEATURE_DEV_TOOLS = 'dev-tools-panel'
export const FEATURE_CLOUDFLARE_IMAGE_OPTIMIZATION =
  'cloudflare-image-optimization'
export const FEATURE_CONTENT_CREATOR_ROLE = 'content-creator-role'
export const FEATURE_START_ROUTE_LEARNING_PATH_STATIC =
  'start-route-learning-path-static'
export const FEATURE_START_ROUTE_LEARNING_PATH_DYNAMIC =
  'start-route-learning-path-dynamic'
export const FEATURE_TRANSFER_LICENSES_FORM = 'transfer-licenses-form'
export const FEATURE_ROLES_OVERVIEW = 'roles-overview'
export const FEATURE_PACE_SPEECH_TO_SPEECH = 'speech-to-speech'
export const FEATURE_START_ROUTE_SIGNATURE_COURSE_DIGITALIZATION =
  'start-route-signature-course-digitalization'
export const FEATURE_START_ROUTE_SIGNATURE_COURSE_AI =
  'start-route-signature-course-ai'
export const FEATURE_START_ROUTE_SIGNATURE_COURSE_PROJECT_MANAGEMENT =
  'start-route-signature-course-project-management'
export const FEATURE_START_ROUTE_SIGNATURE_COURSE_LEADERSHIP =
  'start-route-signature-course-leadership'
export const FEATURE_START_ROUTE_SIGNATURE_COURSE_FUNDAMENTALS_OF_DIGITALIZATION_2_0 =
  'start-route-signature-course-fundamentals-of-digitalization-2-0'
export const FEATURE_LICENSES_TREE = 'licenses-tree'
export const FEATURE_LEARNPATH_RECURRING = 'learnpath-recurring'
export const FEATURE_COMPANY_SPACE_COMMUNITY_WIDGET =
  'company-space-community-widget'
export const FEATURE_COMPANY_SPACE_OVERVIEW = 'company-space-overview'
export const FEATURE_LEARNPATH_NOTIFICATIONS_SETTINGS =
  'learnpath-notifications-settings'
export const FEATURE_LEARNPATH_NOTIFICATIONS_SETTINGS_FOOTER =
  'learnpath-notifications-settings-footer'
export const FEATURE_LEARNPATH_LEARNER_MANAGEMENT =
  'learnpath-learner-management'
export const FEATURE_MODULAR_DASHBOARD = 'modular-dashboard'
export const FEATURE_ENHANCED_DATA_TABLE = 'enhanced-data-table'
export const FEATURE_EASTER_EGG = 'easter-egg'
export const FEATURE_INVITE_LANGUAGE_SELECTION = 'invite-language-selection'
export const FEATURE_VIDEO_PLAYER_REPORT = 'video-player-report'
export const FEATURE_VIDEO_PLAYER_REPORT_AUDIO = 'video-player-report-audio'
export const FEATURE_STARTING_PAGE = 'starting-page'
export const FEATURE_USERS_TABLE_CUSTOMIZABLE_COLUMNS =
  'users-table-customizable-columns'
export const FEATURE_USER_GROUPS_TABLE_CUSTOMIZABLE_COLUMNS =
  'user-groups-table-customizable-columns'
export const FEATURE_AI_ASSISTANT = 'ai-assistant'
export const FEATURE_AI_ASSISTANT_SHOW_SESSION_ID =
  'ai-assistant-show-session-id'
export const FEATURE_AI_ASSISTANT_DEBUG = 'ai-assistant-debug'
export const FEATURE_AI_ASSISTANT_FEEDBACK = 'ai-assistant-feedback'
export const FEATURE_AI_ASSISTANT_MODEL_SWITCHER = 'ai-assistant-model-switcher'

export const FEATURE_FLAGS = [
  FEATURE_ACHIEVEMENTS,
  FEATURE_ACTIVITY_LOG,
  FEATURE_ACTIVITY_LOG_COMPANY,
  FEATURE_AUDIT_LOG,
  FEATURE_AD_AVERAGE_ACTIVITY_TIME_LP,
  FEATURE_AD_AVERAGE_COMPLETION_RESULT_METRIC,
  FEATURE_AD_AVERAGE_COURSE_RATING,
  FEATURE_AD_AVERAGE_SCORE_POWER_SKILLS,
  FEATURE_AD_COMPLETED_COURSES,
  FEATURE_AD_COMPLETED_LESSONS,
  FEATURE_AD_COURSE_STARTERS_COMPLETERS,
  FEATURE_AD_HIGHEST_LEVEL_POWER_SKILL,
  FEATURE_AD_HIGHEST_LEVEL_POWER_SKILLS,
  FEATURE_AD_LP_ACTIVITY_BY_TYPE,
  FEATURE_AD_LESSONS_RATINGS_TOTAL,
  FEATURE_AD_LICENSES,
  FEATURE_AD_LP_ELEMENTS_ACTIVITY_BY_TYPE,
  FEATURE_AD_LP_PROGRESS,
  FEATURE_AD_LP_STARTERS_COMPLETERS,
  FEATURE_AD_MOST_POPULAR_COURSE,
  FEATURE_AD_MOST_POPULAR_DOMAIN,
  FEATURE_AD_MOST_POPULAR_POWER_SKILL,
  FEATURE_AD_POWER_SKILL_MOST_POINTS_ACHIEVED,
  FEATURE_AD_COURSE_STARTS_COMPLETIONS,
  FEATURE_AD_LESSONS_STARTS_COMPLETIONS,
  FEATURE_AD_LP_STARTS_COMPLETIONS,
  FEATURE_AD_LP_ELEMENTS_STARTS_COMPLETIONS,
  FEATURE_AD_TOP_10_POPULAR_SEARCHES,
  FEATURE_AD_TOP_5_COMPLETED_LESSONS,
  FEATURE_AD_TOP_5_MOST_COMPLETED_COURSES,
  FEATURE_AD_TOP_5_RATED_LESSONS,
  FEATURE_AD_TOTAL_USERS_ACTIVITY_TIME,
  FEATURE_AD_TOTAL_USERS,
  FEATURE_AD_USERS,
  FEATURE_AD_USERS_COMPLETED_SKILL_ASSESSMENT,
  FEATURE_AD_USERS_FINISHED_FUNDAMENTAL_COURSE,
  FEATURE_AD_USERS_LEARNING_GROUPS,
  FEATURE_AD_USERS_MIN_1_USER_RATING,
  FEATURE_AD_USERS_POWER_SKILLS,
  FEATURE_AD_USERS_RATED_1_COURSE,
  FEATURE_AI_COURSE_DASHBOARD_POD,
  FEATURE_BATCH_OPERATIONS,
  FEATURE_BATCH_OPERATIONS_USER_EDIT,
  FEATURE_BATCH_OPERATIONS_USER_DEACTIVATE,
  FEATURE_BATCH_OPERATIONS_USER_REACTIVATE,
  FEATURE_BATCH_OPERATIONS_USER_GROUP_ASSIGN,
  FEATURE_BATCH_OPERATIONS_DEPARTMENT_ASSIGN,
  FEATURE_BROWSER_NOTIFICATIONS,
  FEATURE_ANALYTICS,
  FEATURE_CERTIFICATE,
  FEATURE_TOPIC_CERTIFICATE,
  FEATURE_COMPANY,
  FEATURE_ROLES_OVERVIEW,
  FEATURE_CONTENT_LANGUAGE_FLAGS,
  FEATURE_CORE_SKILLS_ASSESSMENT,
  FEATURE_DASHBOARD_BEST_TOPICS_CHANNEL,
  FEATURE_DASHBOARD_BOOKMARKED,
  FEATURE_DASHBOARD_CHANNELS,
  FEATURE_DASHBOARD_COMPLETED,
  FEATURE_DASHBOARD_COURSE,
  FEATURE_DASHBOARD_CURRENT_LECTURE,
  FEATURE_DASHBOARD_HIGHLIGHTED_TOPIC,
  FEATURE_DASHBOARD_EXCLUSIVE_CHANNEL,
  FEATURE_DASHBOARD_ADVENT_CALENDAR_CHANNEL,
  FEATURE_DASHBOARD_LEARNPATH,
  FEATURE_DASHBOARD_LEARNPATH_COMPANY,
  FEATURE_DASHBOARD_NEW_TOPICS_CHANNEL,
  FEATURE_DASHBOARD_USER_CHANNEL,
  FEATURE_DISCOVER,
  FEATURE_DISCOVER_ADVANCED_FILTERS,
  FEATURE_DOWNLOAD_NOTES,
  FEATURE_EXPORT_CONTENT_AS_SCORM,
  FEATURE_GLOSSARY,
  FEATURE_GROWTH_MAP,
  FEATURE_LEARNGROUP,
  FEATURE_LEARNING_ELEMENTS_TRACKING,
  FEATURE_LEARNPATH,
  FEATURE_LEARNPATH_AS_A_COURSE,
  FEATURE_LEARNPATH_BLENDED_LEARNING,
  FEATURE_LEARNPATH_CERTIFICATE_ISSUE,
  FEATURE_LEARNPATH_EMBEDDED_VIDEO,
  FEATURE_LEARNPATH_FILE_UPLOAD,
  FEATURE_LEARNPATH_MANDATORY,
  FEATURE_LEARNPATH_MASTERPLAN_CONTENT,
  FEATURE_LEARNPATH_MY_LEARNERS_ONLY_FILTER,
  FEATURE_LEARNPATH_ACTIVE_ONLY_FILTER,
  FEATURE_LEARNPATH_MANDATORY_ONLY_FILTER,
  FEATURE_LEARNPATH_OWNER,
  FEATURE_LEARNPATH_PDF_PREVIEW,
  FEATURE_LEARNPATH_POINTS,
  FEATURE_LEARNPATH_QUIZ,
  FEATURE_LEARNPATH_QUIZ_MULTIPLE_CHOICE,
  FEATURE_LEARNPATH_QUIZ_THRESHOLD,
  FEATURE_LEARNPATH_STATS_DEFAULT_COMPANY_ADMIN,
  FEATURE_LEARNPATH_STATS_DEFAULT_MANAGER,
  FEATURE_LEARNPATH_STATS_DEFAULT_OWNER,
  FEATURE_LEARNPATH_STATS_MANDATORY_COMPANY_ADMIN,
  FEATURE_LEARNPATH_STATS_MANDATORY_MANAGER,
  FEATURE_LEARNPATH_STATS_MANDATORY_OWNER,
  FEATURE_LEARNPATH_STATS_DEACTIVATED_USERS_FILTER,
  FEATURE_LEARNPATH_TEXT_LECTURE,
  FEATURE_LEARNPATH_THUMBNAILS,
  FEATURE_LEARNPATH_TRANSFER_LEARNING_PROGRESS,
  FEATURE_LEARNPATH_TRANSLATIONS,
  FEATURE_LEARNPATH_VIDEO_UPLOAD,
  FEATURE_LINK_SHARING,
  FEATURE_LEARNPATH_LEARNER_MANAGEMENT,
  FEATURE_MONTHLY_CHALLENGE,
  FEATURE_NOTIFICATIONS,
  FEATURE_NOTIFICATIONS_SYSTEM,
  FEATURE_NO_EMAIL_USERS,
  FEATURE_SIGNUP_AVATAR,
  FEATURE_SIGNUP_DATE_OF_BIRTH,
  FEATURE_SIGNUP_EMAIL_REQUIRED,
  FEATURE_SIGNUP_FIELD_OF_ACTIVITY,
  FEATURE_SIGNUP_GENDER,
  FEATURE_SIGNUP_POLL,
  FEATURE_SIGNUP_PRIVACY_POLICY,
  FEATURE_SIGNUP_PRIVACY_POLICY_VOLKSWAGEN,
  FEATURE_SIGNUP_PROFILE,
  FEATURE_SOCIAL_AUTH,
  FEATURE_USERPILOT,
  FEATURE_USER_NOTES,
  FEATURE_USER_GROUPS,
  FEATURE_USER_GROUP_MEMBERS_EXPORT,
  FEATURE_USER_MANAGEMENT,
  FEATURE_USERS_EXPORT,
  FEATURE_VIDEO_PLAYER_THUMBNAILS,
  FEATURE_SNOW,
  FEATURE_CLOUDFLARE_IMAGE_OPTIMIZATION,
  FEATURE_CONTENT_CREATOR_ROLE,
  FEATURE_TRANSFER_LICENSES_FORM,
  FEATURE_PACE_SPEECH_TO_SPEECH,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_DIGITALIZATION,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_AI,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_PROJECT_MANAGEMENT,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_LEADERSHIP,
  FEATURE_START_ROUTE_SIGNATURE_COURSE_FUNDAMENTALS_OF_DIGITALIZATION_2_0,
  FEATURE_LICENSES_TREE,
  FEATURE_COMPANY_SPACE_COMMUNITY_WIDGET,
  FEATURE_COMPANY_SPACE_OVERVIEW,
  FEATURE_LEARNPATH_NOTIFICATIONS_SETTINGS,
  FEATURE_LEARNPATH_NOTIFICATIONS_SETTINGS_FOOTER,
  FEATURE_MODULAR_DASHBOARD,
  FEATURE_ENHANCED_DATA_TABLE,
  FEATURE_EASTER_EGG,
  FEATURE_INVITE_LANGUAGE_SELECTION,
  FEATURE_VIDEO_PLAYER_REPORT,
  FEATURE_VIDEO_PLAYER_REPORT_AUDIO,
  FEATURE_STARTING_PAGE,
  FEATURE_USERS_TABLE_CUSTOMIZABLE_COLUMNS,
  FEATURE_USER_GROUPS_TABLE_CUSTOMIZABLE_COLUMNS,
  FEATURE_AI_ASSISTANT,
  FEATURE_AI_ASSISTANT_SHOW_SESSION_ID,
  FEATURE_AI_ASSISTANT_DEBUG,
  FEATURE_AI_ASSISTANT_FEEDBACK,
  FEATURE_AI_ASSISTANT_MODEL_SWITCHER,
]
